module.exports = __webpack_public_path__ + "img/avatar.759f07e8.jpg";